import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_downshift__ from "downshift";
import * as __WEBPACK_EXTERNAL_MODULE__AutocompleteListItem_AutocompleteListItem_js_aadd75e2__ from "./AutocompleteListItem/AutocompleteListItem.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__ from "../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__InputText_index_js_541df238__ from "../InputText/index.js";
function getIconName(itemLocationType) {
    if ('AIRPORT' === itemLocationType) return 'flight_takeoff';
    if ('POI' === itemLocationType) return 'location_on';
    return 'location_city';
}
function Autocomplete({ autocompleteData, handleInputChange }) {
    const [items, setItems] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)([
        ...autocompleteData
    ]);
    const [selectedItem, setSelectedItem] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(null);
    const [highlightedIndexWithKeyArrow, setHighlightedIndexWithKeyArrow] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(-1);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        setItems([
            ...autocompleteData
        ]);
    }, [
        autocompleteData
    ]);
    const { isOpen, getMenuProps, getInputProps, highlightedIndex, getItemProps } = (0, __WEBPACK_EXTERNAL_MODULE_downshift__.useCombobox)({
        onInputValueChange ({ inputValue }) {
            if ('' === inputValue) setSelectedItem(null);
            handleInputChange(inputValue);
        },
        onSelectedItemChange ({ selectedItem }) {
            setSelectedItem(selectedItem);
        },
        onHighlightedIndexChange: (event)=>{
            '__input_keydown_arrow_down__' === event.type || '__input_keydown_arrow_up__' === event.type ? setHighlightedIndexWithKeyArrow(event.highlightedIndex) : setHighlightedIndexWithKeyArrow(-1);
        },
        items,
        itemToString (item) {
            return item ? item.itemName : '';
        }
    });
    const inputRef = __WEBPACK_EXTERNAL_MODULE_react__["default"].useRef(null);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__InputText_index_js_541df238__.InputText, {
                iconLeft: "search",
                isInset: true,
                label: "Where to?",
                "data-testid": "autocomplete-input",
                ref: inputRef,
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("ul", {
                className: `flex flex-col gap-1 shadow-md ${!(isOpen && items.length) && 'hidden'} rounded-xl p-1`,
                ...getMenuProps(),
                children: isOpen && items.length > 0 && items.map((item, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__AutocompleteListItem_AutocompleteListItem_js_aadd75e2__.AutocompleteListItem, {
                        firstLine: item.displayLine1 ?? item.itemName,
                        secondLine: item.displayLine2 ?? '',
                        leftNode: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                            palette: "primary",
                            shade: "10",
                            iconName: getIconName(item.type),
                            size: "24"
                        }),
                        isHighlighted: highlightedIndex === index,
                        isHighlightedIndexWithKeyArrow: highlightedIndexWithKeyArrow === index,
                        isSelected: selectedItem?.itemName === item.itemName,
                        ...getItemProps({
                            item,
                            index,
                            onKeyDown: (e)=>console.log(e.key)
                        })
                    }, `${item.itemName}`))
            })
        ]
    });
}
export { Autocomplete };
